import React from "react";
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";
import { FormattedMessage, useIntl } from "react-intl";

import styles from "./countrySection.module.scss";
import { renderWithBreaks } from '@utils/translations';

const CountrySection = ({
  name,
  capitalCity,
  currencySymbol,
  currencyCode,
  callingCode,
  countryDescription,
  countryImage,
  countryFlag,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.intro} key={callingCode}>
      <div className={styles.intro__image}>
        <Imgix
          className="lazyload"
          src={countryImage.url}
          alt={countryImage.alt ? countryImage.alt : intl.formatMessage({ id: name })}
          sizes='(min-width: 36em) 600px, 90vw'
          imgixParams={{ auto: 'compress,format' }}
          attributeConfig={{
            src: 'data-src',
            srcSet: 'data-srcset',
            sizes: 'data-sizes',
          }}
          htmlAttributes={{
            src: buildURL(countryImage.url, { auto: 'compress,format', blur: 50, w: 200 }),
          }}
        />
      </div>
      <div className={styles.intro__info}>
        <div className={styles.intro__info__attributes}>
          <div className={styles.intro__info__attributes__leftBlock}>
            <div className={styles.intro__info__attributes__leftBlock__key}>
              <p>
                <FormattedMessage id="Capital city" />
              </p>
              <p>
                <FormattedMessage id="Currency" />
              </p>
              <p>
                <FormattedMessage id="Calling code" />
              </p>
            </div>
            <div className={styles.intro__info__attributes__leftBlock__value}>
              <p>{intl.formatMessage({ id: capitalCity })}</p>
              <p>
                {currencySymbol} <span>({currencyCode})</span>
              </p>
              <p>{callingCode}</p>
            </div>
          </div>
          <div className={styles.intro__info__attributes__rightBlock}>
            <Imgix
              className="lazyload"
              src={countryFlag.url}
              alt={countryFlag.alt ? countryFlag.alt : intl.formatMessage({ id: name })}
              width={30}
              imgixParams={{ auto: 'compress,format' }}
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: buildURL(countryFlag.url, { auto: 'compress,format', blur: 50, w: 30 }),
              }}
            />
          </div>
        </div>
        <div className={styles.intro__info__description}>
          <p>
            {countryDescription ? renderWithBreaks(intl.formatMessage({ id: `${name} description` })) : null}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CountrySection;
